import { ICalendarEvent, ISidebarRouteState } from 'components';
import React from 'react';
import { IHomeCalendarData } from '../Home';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ListStage } from '../ListStage';

export function renderAgenda(
    events: ICalendarEvent<IHomeCalendarData>[],
    routeState: ISidebarRouteState,
) {
    return <>
        <div className="home_colHeaders">
            <div className="home_colHeader home_colHeadersUpdate">
                Update
            </div>
            <div className="home_colHeader home_colHeadersDates">
                <div className="home_colHeadersDateFrom">Start Time</div>
                <div className="home_colHeadersDateSeparator"></div>
                <div className="home_colHeadersDateTo">End Time</div>
            </div>
            <div className="home_colHeader home_colHeadersStatus">
                Status
            </div>
        </div>
        <div className="home_list">
            {events.length > 0 && events.map((e) => {
                return (<ListStage
                    key={e.id}
                    linkRouteState={routeState}
                    stageIndex={e.data.stageIndex}
                    update={e.data.update}
                />);
            })}
            {events.length === 0 && (
                <div className="home_listEmpty">
                    <FontAwesomeIcon icon="search" className="home_listEmptyIcon" />
                    <div className="home_listEmptyText">
                        No updates found for this date range.
                    </div>
                </div>
            )}
        </div>
    </>
}